<template lang="pug">
  .content.content-profile.white-fone
    .tile.is-ancestor.section-wrap(style="position: relative")
      .tile.is-9.left-section
        .left
          .title
            .title-inner
              .name {{ cv.first_name }}
                span {{' ' + cv.last_name}}
              .profession(v-if="cv.has_profession && cv.profession") {{ cv.profession ? cv.profession.name : cv.profession_company_type.name}}
            .title-inner.flex-end.id-wrap
              <!--.verified-->
                <!--img(src="/webapp/svg/tick-green.svg")-->
                <!--span {{ gettext('verified') }}-->
              .id
                span(v-if="cv.is_partner && cv.partner_code")
                  | {{cv.partner_code}}
                span
                  | ID: {{ $route.params.id }}
              <!--.couple-->
                <!--img(src="/webapp/svg/account.svg")-->
                <!--img(src="/webapp/svg/account-red.svg")-->
                <!--span {{ gettext('couple cv') }}-->
          .actions
            .action-btn.red(@click="requestModal = true") {{ gettext('Send request') }}
            a.action-btn.black(v-if="pdf.url" target="_blank" :href="pdf.url") {{ gettext('Download PDF') }}
            <!--router-link.action-btn.red(v-if="!cv.available_cvcontacts_access_hits && !cv.has_cvcontacts_access" :to="{name:'AccountPlan', params:{lang: getLanguage}}" :tag="'button'") {{ gettext('Buy CV') }}-->
            <!--.action-btn.red(v-else-if="!cv.has_cvcontacts_access" @click="confirmModal = true") {{ interpolate(ngettext('Open contact (%s hit)', 'Open contact (%s hits)', cv.available_cvcontacts_access_hits), [cv.available_cvcontacts_access_hits]) }}-->
            .action-btn(v-if="getUser.profile_type === CONSTANTS.EMPLOYER_PROFILE_TYPE || getUser.profile_type === CONSTANTS.RECEIVER_PROFILE_TYPE" @click="favoriteHandler") {{ !cv.is_wish ? gettext('Add to favorites') : gettext('Remove from favorites') }}
          .description(v-if="cv.about")
            pre {{cv.about}}
          <!--.video-->
            <!--div-->
              <!--img(src="/webapp/svg/play.svg")-->
              <!--span View video-->
          .info-section
            .info-title {{ gettext('General information') }}
            <!--.info-item(v-if="cv.is_partner")-->
              <!--p.type.partner {{ gettext('Partner') }}-->
            .info-item(v-if="cv.profession_company_type")
              div {{ gettext('Considering industry') }}
              span {{ cv.profession_company_type.name }}
            .info-item(v-if="cv.is_trainee")
              div {{ gettext('Type of employment') }}
              span {{ gettext('Trainee') }}
            .info-item(v-else)
              div {{ gettext('Type of employment') }}
              span(v-if="cv.type === CONSTANTS.TYPE_PERMANENT_WORK && cv.is_skilled") {{ gettext('Skilled worker') }}
              span(v-if="cv.type === CONSTANTS.TYPE_PERMANENT_WORK && !cv.is_skilled") {{ gettext('Unskilled worker') }}
              span(v-if="cv.type === CONSTANTS.TYPE_SEASONAL_WORK && cv.is_skilled") {{ gettext('Seasonal/Skilled worker') }}
              span(v-if="cv.type === CONSTANTS.TYPE_SEASONAL_WORK && !cv.is_skilled") {{ gettext('Seasonal/Unskilled worker') }}
            .info-item(v-if="(cv.age || [] )[0]")
              div {{ gettext('Age') }}
              span {{ cv.birth_year | age }}
            .info-item(v-if="cv.jobseeker.gender")
              div {{ gettext('Gender') }}
              span(v-if="cv.jobseeker.gender === 10") {{gettext('Male') }}
              span(v-if="cv.jobseeker.gender === 20") {{ gettext('Female') }}
            .info-item(v-if="cv.jobseeker")
              div {{ gettext('Original nationality') }}
              span {{ cv.jobseeker.country.name }}
            .info-item(v-if="(cv.jobseeker || {}).marital_status")
              div {{ gettext('Marital status') }}
              span {{ cv.jobseeker.marital_status.name }}
            .info-item
              div {{ gettext('EU Citizenship') }}
              span {{ cv.eu_citizenship ? 'Yes' : 'No' }}
            .info-item(v-if="cv.height")
              div {{ gettext('Height') }}
              span {{ cv.height }} {{ gettext('cm') }}
            .info-item(v-if="cv.weight")
              div {{ gettext('Weight') }}
              span {{ cv.weight }} {{ gettext('kg') }}
          .info-section
            .info-title {{ gettext('Location of residence') }}
            .info-item(v-if="cv.location_country")
              div {{ gettext('Country of residence') }}
              span {{ cv.location_country.name }}
            .info-item(v-if="cv.location_city")
              div {{ gettext('City of residence') }}
              span {{ cv.location_city }}
            .info-item(v-if="cv.location_staying_type")
              div {{ gettext('Staying type') }}
              span {{ cv.location_staying_type.name }}
          .info-section(v-if="cv.has_cvcontacts_access")
            .info-title {{ gettext('Contact Information') }}
            .info-item(v-if="cv.phone")
              div {{ gettext('Phone') }}
              span {{ cv.phone }}
            .info-item(v-if="cv.email")
              div {{ gettext('Email') }}
              span {{ cv.email }}
            .info-item(v-if="cv.skype")
              div {{ gettext('Skype') }}
              span {{ cv.skype }}
            .info-item(v-if="cv.facebook")
              div {{ gettext('Facebook') }}
              span {{ cv.facebook }}
            .info-item(v-if="cv.linkedin")
              div {{ gettext('Linkedin') }}
              span {{ cv.linkedin }}
          .info-section(v-if="(cv.work_experiences || []).length")
            .info-title {{ gettext('Work Experience') }}
            .info-item-separator(v-for="(experience, index) in cv.work_experiences")
              .info-item
                div {{ gettext('Work period') }}
                span {{ gettext('from') }} {{experience.period_from | dateNormalize}} {{ gettext('to') }} {{experience.period_to | dateNormalize}}
              .info-item(v-if="experience.company && cv.has_cvcontacts_access")
                div {{ gettext('Company') }}
                span {{ experience.company }}
              .info-item
                div {{ gettext('Country') }}
                span {{ experience.country.name }}
              .info-item(v-if="experience.position")
                div {{ gettext('Position') }}
                span {{ experience.position }}
              .info-item
                div {{ gettext('Industry') }}
                span {{ experience.company_type.name }}
              .info-item(v-if="experience.profession")
                div {{ gettext('Profession') }}
                span {{ experience.profession.name }}
              .info-item
                div {{ gettext('Sector') }}
                span {{ experience.company_sector.name }}
              .info-item(v-if="experience.responsibilities")
                div {{ gettext('Responsibility') }}
              .description.mt
                pre {{ experience.responsibilities }}
          .info-section
            .info-title {{gettext('Education')}}
            .info-item-separator(v-for="(education, index) in cv.educations")
              .info-item
                div {{ gettext('Type of education') }}
                span {{ education.education_type.name }}
              .info-item(v-if="education.education_status")
                div {{ gettext('Education status') }}
                span {{ (education.education_status || {}).name }}
              .info-item
                div {{ gettext('Educational institution') }}
                span {{ education.institution }}
              .info-item(v-if="education.faculty")
                div {{ gettext('Faculty, specialty') }}
                span {{ education.faculty }}
              .info-item
                div {{ gettext('Country') }}
                span {{ education.country.name }}
              .info-item(v-if="education.period_from && education.period_to")
                div {{ gettext('Period') }}
                span {{ gettext('from') }} {{education.period_from | dateNormalize}} {{ gettext('to') }} {{education.period_to | dateNormalize}}
              .info-item(v-if="education.description")
                div {{ gettext('Description') }}
              .description.mt
                pre {{ education.description }}
          .info-section
            .info-title {{gettext('Languages')}}
            .info-item-separator(v-for="(language, index) in cv.languages")
              .info-item
                div {{ gettext('Language') }}
                span {{ language.language.name }}
              .info-item
                div {{ gettext('Level') }}
                span {{ language.level.name }}
          .info-section(v-if="(cv.driving_licences || []).length")
            .info-title {{ gettext('Driver\'s license') }}
            .driving-licenses
              div(v-for="licence in cv.driving_licences") {{ licence.name }}
          .info-section(v-if="(cv.documents_urls || []).length")
            .info-title {{ gettext('Documents') }}
            .documents
              documents(:files="cv.documents_urls" :hasAccess="cv.has_cvcontacts_access")
          .grid.top-space.wide.one-quarter-right.services
            div.block
              p {{ gettext('We can help you hire this employee. You can order our services, which will help you test a person and help her start working for you.') }}
            div.block
              .field
                .field-body
                  router-link.main-btn.bg-transparent(:to="{name: 'PaperWork', params: {lang:getLanguage}}") {{ gettext('Paperwork') }}
            div.block.m-t-1
              p {{ gettext('Also we can help to find a perfect employee, just use our service.') }}
            div.block
              .field
                .field-body
                  router-link.main-btn.bg-transparent(:to="{name: 'PersonalMatch', params: {lang:getLanguage}}") {{ gettext('Matching') }}
      .tile.is-3.right-section
        .right
          .avatar-wrap
            .avatar
              div(v-if="cv.image_urls" :style="{'background-image': `url(${(cv.image_urls || {}).mid})`}")
              div.red(v-else)
    v-modal(:show.sync="thankModal" :clickAway="true")
      section.modal-card-body.requestMOdal
        h3.thank-you {{ gettext('Thank you, we will contact you as soon as possible!') }}
    v-modal.contact-form(:show.sync="requestModal" :clickAway="true")
      section.modal-card-body.requestMOdal
        .level
          .level-left {{ cv.first_name }} {{ cv.last_name }} ID {{ $route.params.id }}
          .level-right {{ (cv.profession || {}).name }}
        .tile.field(v-if="(!$auth.check())")
          .field-body
            input.input(:placeholder="gettext('Name')" v-model="requestForm.name")
        .tile.field(v-if="(!$auth.check())")
          .field-body
            v-phone-input(
            name="phone"
            v-model="requestForm.phone"
            @blur="validateData('phone')"
            :class="{'is-danger': $v.requestForm.phone.$error, 'is-empty': !requestForm.phone}"
            @onInput="requestForm.phone = $event.number"
            :phone="requestForm.phone"
            )
        .tile.field(v-if="(!$auth.check())")
          .field-body
            input.input(:placeholder="gettext('Email')"
            v-model="requestForm.email"
            @blur="validateData('email')"
            :class="{'is-danger': $v.requestForm.email.$error, 'is-empty': !requestForm.email}"
            )
        .tile.field
          .field-body
            textarea.textarea(
            :placeholder="gettext('Text')"
            v-model="requestForm.text"
            v-tooltip="{content: errors.required, show: tooltip.text}"
            :class="{'is-danger': $v.requestForm.text.$error, 'is-empty': !requestForm.text}"
            @blur="validateData('text')"
            )
        .tile.field(v-if="(!$auth.check())")
          .field-body
            input#custom-checkbox.is-checkradio.custom-checkbox(type="checkbox" v-model="requestForm.agree")
            label.checkbox(for="custom-checkbox")
              | {{ gettext('I agree to the') }} &nbsp;
              router-link(:to="`/${getLanguage}/terms-and-conditions`" target='_blank') {{ gettext('terms and conditions') }}
          label.label.is-hidden-mobile
        .tile.btns
          .main-btn.col-white.bg-red(
          @click="sendRequest()"
          :disabled="$v.$invalid || (!$auth.check() && !requestForm.agree) || loading"
          ) {{ gettext('Send request') }}
    v-modal(:show.sync="confirmModal" :clickAway="true")
      section.modal-card-body
        .is-size-4.has-text-centered.title {{ gettext('Are you sure you want to open contact information?') }}
        .btn-wrap(v-if="cv.available_cvcontacts_access_hits")
          button.main-btn.col-white.bg-red.nav-item.is-tab(@click="openContacts()") {{ interpolate(ngettext('Yes. Use one of %s hit', 'Yes. Use one of %s hits', cv.available_cvcontacts_access_hits), [cv.available_cvcontacts_access_hits]) }}
          button.main-btn.col-white.bg-black.nav-item.is-tab(@click="confirmModal = false") {{ gettext('Cancel') }}
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import { gettext, ngettext, interpolate } from '@/services/TranslateHandler'
import Contacts from './parts/contacts'
import Documents from './parts/documents'
import moment from 'moment'
import VModal from '@/components/modal'
import CONSTANTS from '@/constants'
import VPhoneInput from '@/components/v-phone-input'
import { required, requiredIf, email } from 'vuelidate/lib/validators'

const inactive = require('@/constants.json')
const _ = require('lodash')

export default {
  name: 'ProfileView',
  components: {
    Contacts,
    Documents,
    VModal,
    VPhoneInput
  },
  data () {
    return {
      inactive: inactive,
      confirmModal: false,
      requestModal: false,
      thankModal: false,
      CONSTANTS: CONSTANTS,
      employer: (this.$store.getters.getUser || {}).profile_type === 20,
      tooltip: {},
      sent: false,
      loading: false,
      pdf: '',
      requestForm: {
        name: '',
        email: '',
        phone: '',
        text: '',
        agree: false
      }
    }
  },
  validations () {
    if (this.$auth.check()) {
      return {
        requestForm: {
          text: {required}
        }
      }
    } else {
      return {
        requestForm: {
          text: {required},
          email: {
            email,
            required: requiredIf(() => {
              return !this.requestForm.phone
            })
          },
          phone: {
            required: requiredIf(() => {
              return !this.requestForm.email
            })
          },
          name: {}
        }
      }
    }
  },
  filters: {
    age: function (date) {
      let formatted = (moment().format('YYYY') - date)
      return interpolate(ngettext('%s year (%s)', '%s years (%s)', formatted), [formatted, date])
    },
    dateNormalize: function (date) {
      if (date === null) {
        return gettext('present')
      }
      return date.replace(new RegExp('-', 'g'), '/')
    }
  },
  props: {
    cv: {
      default: () => {
        return {}
      }
    },
    package: {
      default: null
    }
  },
  methods: {
    ...mapActions([
      'hitContactAccess',
      'addCvTofavorites',
      'deleteCvfromfavorites',
      'sendCvsRequestNonAuth',
      'sendCvsRequestAuth',
      'getCvPdf'
    ]),
    gettext: gettext,
    ngettext: ngettext,
    interpolate: interpolate,
    sendRequest () {
      this.validateData()
      this.loading = true
      if (this.$auth.check()) {
        this.sendCvsRequestAuth({
          lang: this.getLanguage,
          form_data: {
            text: this.requestForm.text,
            cv: parseInt(this.$route.params.id)
          }
        }).then(res => {
          if (res.success) {
            this.thankModal = true
            this.clearRequestForm()
            this.loading = false
            setTimeout(() => {
              this.thankModal = false
            }, 3000)
          }
        })
      } else {
        this.sendCvsRequestNonAuth({
          lang: this.getLanguage,
          form_data: {
            name: this.requestForm.name,
            email: this.requestForm.email,
            phoneNumber: this.requestForm.phone,
            text: this.requestForm.text,
            agree: this.requestForm.agree,
            cv: parseInt(this.$route.params.id)
          }
        }).then(res => {
          if (res.success) {
            this.thankModal = true
            this.clearRequestForm()
            this.loading = false
            setTimeout(() => {
              this.thankModal = false
            }, 3000)
          }
        })
      }
    },
    clearRequestForm () {
      this.$v.$reset()
      this.requestModal = false
      this.requestForm = {
        name: '',
        email: '',
        phone: '',
        text: '',
        agree: false
      }
    },
    validateData (item) {
      if (item) {
        this.$v.requestForm[item].$touch()
        if (this.$v.requestForm[item].$error) {
          this.$set(this.tooltip, item, true)
        }
        setTimeout(() => {
          this.tooltip[item] = false
        }, 3000)
      } else {
        this.$v.$touch()
        let errors = this.$v.requestForm
        _.each(errors, (item, key) => {
          if (!key.includes('$')) {
            if (errors[key].$error) {
              this.$set(this.tooltip, key, true)
            }
          }
        })
        setTimeout(() => {
          _.each(this.tooltip, (item, key) => {
            this.tooltip[key] = false
          })
        }, 3000)
      }
    },
    openContacts () {
      this.hitContactAccess({account: this.getFinanceAccount, cv: this.cvID}).then(res => {
        this.$emit('update')
        this.confirmModal = false
      })
    },
    favoriteHandler () {
      if (this.cv.is_wish) {
        this.deleteCvfromfavorites({id: this.cvID}).then(res => {
          if (res.success) {
            this.cv.is_wish = false
          }
        })
      } else {
        this.addCvTofavorites({id: this.cvID}).then(res => {
          if (res.success) {
            this.cv.is_wish = true
          }
        })
      }
    },
    expiredFormat (data) {
      let formatted = moment(data).format('YYYY/MM/DD')
      let difference = moment(data).diff(moment(), 'days')
      return interpolate(ngettext('%s (%s day left)', '%s (%s days left)', difference), [formatted, difference])
    }
  },
  computed: {
    ...mapGetters([
      'getLanguage',
      'getFinanceAccount',
      'getUser'
    ]),
    cvID: function () {
      return parseInt(this.$route.params.id)
    },
    errors () {
      return {
        required: gettext('This field is required')
      }
    }
  },
  created () {
    this.getCvPdf({lang: this.getLanguage, cvID: parseInt(this.$route.params.id)}).then(res => {
      this.pdf = res
    })
  }
}
</script>
<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/pages/cv/parts/profile/index.vue